import React, { useRef, useState, useEffect } from "react";
import Breadcrumb from "../../components/Breadcrumb";
import RightArrow from "../../components/SVG";

import shapeImg from "../../assets/img/contact/shape-2-1.png";
import { createContact } from "../../services/contactServcies";
import toast from "react-hot-toast";

const ContactMain = () => {
  const formRef = useRef();
  const canvasRef = useRef();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });
  const [captcha, setCaptcha] = useState("");
  const [userCaptcha, setUserCaptcha] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Generate random captcha
  const generateCaptcha = () => {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < 6; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setCaptcha(result);
    drawCaptcha(result);
  };

  // Draw captcha on canvas
  const drawCaptcha = (text) => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    // Clear canvas
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Background
    ctx.fillStyle = "#f0f0f0";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Add noise lines
    for (let i = 0; i < 5; i++) {
      ctx.strokeStyle = `hsl(${Math.random() * 360}, 50%, 50%)`;
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
      ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
      ctx.stroke();
    }

    // Add noise dots
    for (let i = 0; i < 50; i++) {
      ctx.fillStyle = `hsl(${Math.random() * 360}, 50%, 50%)`;
      ctx.beginPath();
      ctx.arc(
        Math.random() * canvas.width,
        Math.random() * canvas.height,
        Math.random() * 2,
        0,
        2 * Math.PI
      );
      ctx.fill();
    }

    // Draw text
    ctx.font = "bold 24px Arial";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";

    // Draw each character with random color and slight rotation
    for (let i = 0; i < text.length; i++) {
      ctx.save();
      ctx.fillStyle = `hsl(${Math.random() * 360}, 70%, 30%)`;
      ctx.translate(30 + i * 25, canvas.height / 2);
      ctx.rotate((Math.random() - 0.5) * 0.4);
      ctx.fillText(text[i], 0, 0);
      ctx.restore();
    }
  };

  // Initialize captcha on component mount
  useEffect(() => {
    generateCaptcha();
  }, []);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Validate required fields
    if (
      !formData.name ||
      !formData.email ||
      !formData.phone ||
      !formData.subject
    ) {
      toast.error("Please fill all required fields");
      setIsSubmitting(false);
      return;
    }

    // Validate captcha
    if (userCaptcha.toLowerCase() !== captcha.toLowerCase()) {
      toast.error("Captcha verification failed. Please try again.");
      generateCaptcha(); // Generate new captcha
      setUserCaptcha("");
      setIsSubmitting(false);
      return;
    }

    try {
      // Prepare payload for your API
      const payload = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        subject: formData.subject,
        message: formData.message,
        captcha_verified: true,
      };

      // Call your API function
      const response = await createContact(payload);

      if (response) {
        toast.success("Message sent successfully!");
        // Reset form
        setFormData({
          name: "",
          email: "",
          phone: "",
          subject: "",
          message: "",
        });
        setUserCaptcha("");
        formRef.current.reset();
        generateCaptcha(); // Generate new captcha
      }
    } catch (error) {
      console.error("Error sending message:", error);
      toast.error(error.message || "Failed to send message. Please try again.");
      generateCaptcha(); // Generate new captcha on error
      setUserCaptcha("");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main>
      <Breadcrumb title="Contact Us" />

      <div className="it-contact__area pt-50 pb-50">
        <div className="container">
          <div className="it-contact__wrap fix z-index-3 p-relative">
            <div className="it-contact__shape-1 d-none d-xl-block">
              <img src={shapeImg} alt="" />
            </div>
            <div className="row align-items-center">
              <div className="col-xl-7">
                <div className="it-contact__right-box">
                  <div className="it-contact__section-box pb-20">
                    <h4 className="it-contact__title pb-15">
                      Do you have any queries?
                    </h4>
                    <p>
                      Please fill the form to get the answer of your queries
                    </p>
                  </div>
                  <div className="it-contact__content mb-55">
                    <ul>
                      <li>
                        <div className="it-contact__list d-flex align-items-start">
                          <div className="it-contact__icon">
                            <span>
                              <i className="fa-solid fa-location-dot"></i>
                            </span>
                          </div>
                          <div className="it-contact__text">
                            <span>Our Address</span>
                            <a href="#">
                              Society of Aquaculture Professionals
                              <p style={{ fontWeight: 500 }} className="mb-0">
                                2 & 3, PKM Cross Street, School Road, Mel
                                Ayanambakkam, Chennai - 600 095 Tamil Nadu,
                                India
                              </p>
                            </a>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="it-contact__list d-flex align-items-start">
                          <div className="it-contact__icon">
                            <span>
                              <i className="fa-solid fa-user-headset"></i>
                            </span>
                          </div>
                          <div className="it-contact__text">
                            <span>Help Desk</span>
                            <br className="d-block d-md-none" />
                            <a href="mailto:contact@aquaprofessional.org">
                              contact@aquaprofessional.org
                            </a>
                            <a href="#">+91 9790559513</a>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className="it-contact__bottom-box d-flex align-items-center justify-content-start">
                    <div className="it-footer-social">
                      <a
                        target="_blank"
                        href="https://www.facebook.com/p/Society-of-Aquaculture-Professionals-100063913875757/"
                      >
                        <i className="fa-brands fa-facebook-f"></i>
                      </a>
                      <a
                        target="_blank"
                        href="https://www.linkedin.com/company/aquaprofessional"
                      >
                        <i className="fa-brands fa-linkedin"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-5">
                <div className="it-contact__form-box">
                  <form ref={formRef} onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-12 mb-25">
                        <div className="it-contact-input-box">
                          <label>Name*</label>
                          <input
                            type="text"
                            name="name"
                            placeholder="Name"
                            value={formData.name}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-12 mb-25">
                        <div className="it-contact-input-box">
                          <label>Email Address*</label>
                          <input
                            type="email"
                            name="email"
                            placeholder="Email"
                            value={formData.email}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-12 mb-25">
                        <div className="it-contact-input-box">
                          <label>Phone*</label>
                          <input
                            type="text"
                            name="phone"
                            placeholder="Phone"
                            value={formData.phone}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-12 mb-25">
                        <div className="it-contact-input-box">
                          <label>Subject*</label>
                          <input
                            type="text"
                            name="subject"
                            placeholder="Subject"
                            value={formData.subject}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-12 mb-25">
                        <div className="it-contact-textarea-box">
                          <label>Message</label>
                          <textarea
                            name="message"
                            placeholder="Message"
                            value={formData.message}
                            onChange={handleInputChange}
                          ></textarea>
                        </div>
                      </div>

                      {/* Manual Captcha Section */}
                      <div className="col-12 mb-25">
                        <div className="it-contact-captcha-box">
                          <label>Security Verification*</label>
                          <div
                            className="captcha-container"
                            style={{
                              border: "1px solid #ddd",
                              borderRadius: "5px",
                              padding: "10px",
                              backgroundColor: "#fff",
                              marginBottom: "10px",
                            }}
                          >
                            <canvas
                              ref={canvasRef}
                              width="180"
                              height="50"
                              style={{
                                border: "1px solid #ccc",
                                borderRadius: "3px",
                                display: "block",
                                marginBottom: "10px",
                              }}
                            ></canvas>
                            <div
                              style={{
                                display: "flex",
                                gap: "10px",
                                alignItems: "center",
                              }}
                            >
                              <input
                                type="text"
                                placeholder="Enter captcha code"
                                value={userCaptcha}
                                onChange={(e) => setUserCaptcha(e.target.value)}
                                style={{
                                  flex: 1,
                                  padding: "8px",
                                  border: "1px solid #ddd",
                                  borderRadius: "3px",
                                }}
                                required
                              />
                              <button
                                type="button"
                                onClick={generateCaptcha}
                                style={{
                                  padding: "8px 12px",
                                  backgroundColor: "#007bff",
                                  color: "white",
                                  border: "none",
                                  borderRadius: "3px",
                                  cursor: "pointer",
                                  fontSize: "12px",
                                }}
                                title="Refresh captcha"
                              >
                                ↻
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <button type="submit" disabled={isSubmitting}>
                      <span className="ed-btn-theme">
                        {isSubmitting ? "Sending..." : "Send Message"}
                        <i>
                          <RightArrow />
                        </i>
                      </span>
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ContactMain;
